import { DediconPDFService } from './dedicon-pdf.service';
import { Injectable } from '@angular/core';
import { ReadingService } from './text/reading.service';
import { PdfInstanceManagerService } from './instance/pdf-instance-manager.service';
import { AsgardDocFroala } from '../core/documents/asgard-doc-froala';
import { TabService } from './tab.service';
import { DocumentManagerService } from './document/document-manager.service';
import { AsgardDocPdf } from '../core/documents/asgard-doc-pdf';
// import { ModalWindowService } from './ui/modal-window.service';
// import { CommonMessageDialogComponent } from '../components/dialogs/common-message-dialog/common-message-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastrDialogService } from './toastr-dialog.service';
import { ToastrActionEnum } from '../utils/enums';
import { WebViewerInstance } from '@pdftron/webviewer';


@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(
    private tabService: TabService,
    private pdfService: PdfInstanceManagerService,
    private readonly readingService: ReadingService,
    private readonly docMgrService: DocumentManagerService,
    // private readonly modalService: ModalWindowService,
    private dediconPdfService: DediconPDFService,
    private readonly translate: TranslateService,
    private readonly toastrService: ToastrDialogService,
  ) { }

  async print(): Promise<void> {
    const activeTab = this.tabService.activeTab;
    if (activeTab) {
      if (this.docMgrService.currentDoc instanceof AsgardDocPdf) {
        if (activeTab.isDedicon && this.docMgrService.documentReady) {
          await this.printDedicon();
          return;
        }
        this.printPdf();
      } else if (this.docMgrService.currentDoc instanceof AsgardDocFroala) {
        this.printEditor();
      } else {
        alert('Sorry, document not supported');
      }
    } else {
      alert('Sorry, no document to print');
    }
  }

  printPdf(): void {
    this.readingService.stop();
    if (this.docMgrService.currentDoc) {
      this.docMgrService.currentDoc.clearTextHighlight();

      const activeTab = this.tabService.activeTab;
      if (activeTab) {
        const instance: WebViewerInstance | null = this.pdfService.getViewerInstance(activeTab.id);
        if (instance !== null) {
          instance.UI.print();
        }
      }
    }
  }

  printEditor(): void {
    (this.docMgrService.currentDoc as AsgardDocFroala).print();
  }

  async printDedicon(): Promise<void> {
    const doc = this.docMgrService.currentDoc;
    if (doc && doc instanceof AsgardDocPdf) {
      const instance = this.pdfService.getViewerInstance(doc.documentId);
      if (!instance) {
        return;
      }
      // this.modalService.createModalWindow(
      //   CommonMessageDialogComponent, { messageKey: 'COMMONMESSAGEDIALOG.DEDICON_PRINT' }
      // );

      this.toastrService.showToaster(ToastrActionEnum.Info, this.translate.instant('COMMONMESSAGEDIALOG.DEDICON_PRINT'));
      await this.dediconPdfService.printDediconPage(instance);

      // const sub = this.modalService.openModal.subscribe(async () => {
      //   await this.dediconPdfService.printDediconPage(instance);
      //   sub.unsubscribe();
      // });
    }
  }
}
